import React from 'react';
import { COLORS, FONTS, cardStyle, GradientBanner } from '../signup/signupStyles';
import { getCommunity } from './reflectData';

export const ConditionPicker = ({ conditions, firstName, onSelect }) => (
  <div style={{
    minHeight: '100vh', backgroundColor: COLORS.bg, display: 'flex',
    alignItems: 'center', justifyContent: 'center', padding: '40px 20px',
    fontFamily: FONTS.system
  }}>
    <GradientBanner />
    <style>{`
      @media (max-width: 480px) {
        .reflect-picker-card { padding: 32px 24px !important; }
      }
    `}</style>
    <div className="reflect-picker-card" style={{ ...cardStyle, maxWidth: '520px' }}>
      <h2 style={{
        fontFamily: FONTS.serif, fontSize: 'clamp(22px, 4vw, 28px)',
        fontWeight: '700', color: COLORS.text, margin: '0 0 8px', textAlign: 'center'
      }}>
        Which condition do you want to reflect on first{firstName ? `, ${firstName}` : ''}?
      </h2>
      <p style={{ fontSize: '15px', color: COLORS.muted, margin: '0 0 28px', textAlign: 'center', lineHeight: '1.5' }}>
        You can always come back and answer for your other conditions.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {conditions.map((condition) => {
          const community = getCommunity(condition);
          return (
            <button
              key={condition}
              onClick={() => onSelect(condition)}
              style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                padding: '18px 20px', backgroundColor: '#fff',
                border: `1.5px solid ${COLORS.border}`, borderRadius: '12px',
                cursor: 'pointer', textAlign: 'left', transition: 'all 0.2s', width: '100%'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = COLORS.salmon;
                e.currentTarget.style.boxShadow = '0 2px 12px rgba(235, 160, 155, 0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = COLORS.border;
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div>
                <div style={{ fontSize: '16px', fontWeight: '600', color: COLORS.text, marginBottom: '4px' }}>
                  {condition}
                </div>
                <div style={{ fontSize: '13px', color: COLORS.muted }}>
                  {community.size.toLocaleString()} patients in community
                </div>
              </div>
              <span style={{ fontSize: '18px', color: COLORS.muted }}>&#8250;</span>
            </button>
          );
        })}
      </div>
    </div>
  </div>
);
